import { render, staticRenderFns } from "./CadastroRamais.vue?vue&type=template&id=37edfebe&scoped=true&"
import script from "./CadastroRamais.vue?vue&type=script&lang=js&"
export * from "./CadastroRamais.vue?vue&type=script&lang=js&"
import style0 from "./CadastroRamais.vue?vue&type=style&index=0&id=37edfebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edfebe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
